(function () {
  function initRefurbChecks(root) {
    if (root.dataset.refurbInitialized === 'true') return;

    const track = root.querySelector('[data-refurb-track]');
    const drawer = root.querySelector('[data-refurb-drawer]');
    const accordion = root.querySelector('[data-refurb-accordion]');
    const prevBtn = root.querySelector('[data-refurb-scroll="prev"]');
    const nextBtn = root.querySelector('[data-refurb-scroll="next"]');
    const tiles = root.querySelectorAll('[data-refurb-tile]');
    const items = root.querySelectorAll('[data-refurb-item]');

    if (!track || !drawer || !accordion || !(drawer instanceof HTMLDialogElement)) return;

    root.dataset.refurbInitialized = 'true';

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    let lastFocus = null;

    function closeAllItems(except) {
      items.forEach((item) => {
        const keepOpen = except && item === except;
        item.open = keepOpen;
        item.classList.toggle('is-highlight', keepOpen);
      });
    }

    function updateNav() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollTrack(direction, event) {
      event?.preventDefault();
      const amount = Math.max(track.clientWidth * 0.7, 200);
      track.scrollBy({ left: direction === 'next' ? amount : -amount, behavior: 'auto' });
    }

    function closeDrawer() {
      if (drawer.open) drawer.close();
      document.body.classList.remove('rebx-refurb-drawer-open');
      closeAllItems(null);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus({ preventScroll: true });
        } catch (_) {
          lastFocus.focus();
        }
      }
    }

    function openDrawer(checkId, event) {
      event?.preventDefault();
      event?.stopPropagation();

      lastFocus = document.activeElement;

      const target = accordion.querySelector(`[data-refurb-item="${checkId}"]`);

      closeAllItems(target instanceof HTMLDetailsElement ? target : null);

      if (!drawer.open) {
        drawer.showModal();
        document.body.classList.add('rebx-refurb-drawer-open');
      }

      if (target instanceof HTMLDetailsElement) {
        target.open = true;
        target.classList.add('is-highlight');
        target.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
    }

    prevBtn?.addEventListener('click', (event) => scrollTrack('prev', event));
    nextBtn?.addEventListener('click', (event) => scrollTrack('next', event));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    tiles.forEach((tile) => {
      tile.addEventListener('click', (event) => openDrawer(tile.dataset.refurbTile, event));
    });

    drawer.querySelectorAll('[data-refurb-close]').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        closeDrawer();
      });
    });

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });

    items.forEach((item) => {
      const summary = item.querySelector('.rebx-refurb-checks__item-summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        window.setTimeout(() => {
          if (!item.open) {
            item.classList.remove('is-highlight');
            return;
          }
          items.forEach((other) => {
            if (other === item) return;
            other.open = false;
            other.classList.remove('is-highlight');
          });
          item.classList.add('is-highlight');
        }, 0);
      });
    });

    updateNav();
  }

  function boot() {
    document.querySelectorAll('[data-rebx-refurb-checks]').forEach(initRefurbChecks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
